// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/create_shots.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionShot } from "./vision_shot_pb";
import { file_vision_shotlist_v1_vision_shot } from "./vision_shot_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/create_shots.proto.
 */
export const file_vision_shotlist_v1_create_shots: GenFile = /*@__PURE__*/
  fileDesc("CiV2aXNpb24vc2hvdGxpc3QvdjEvY3JlYXRlX3Nob3RzLnByb3RvEhlwcm90b3MudmlzaW9uLnNob3RsaXN0LnYxIv4DChJDcmVhdGVTaG90c1JlcXVlc3QSRAoGcGFyYW1zGAEgASgLMjQucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVTaG90c1JlcXVlc3QuUGFyYW1zGmIKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEkQKBXNob3RzGAIgAygLMjUucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVTaG90c1JlcXVlc3QuTmV3U2hvdBq9AgoHTmV3U2hvdBITCgtzaG90X251bWJlchgBIAEoCRINCgVzY2VuZRgCIAEoCRIQCghsb2NhdGlvbhgDIAEoCRITCgtkZXNjcmlwdGlvbhgEIAEoCRIQCghjYXN0X2lkcxgFIAMoCRISCgpmcmFtZV9zaXplGAYgASgJEg0KBWFuZ2xlGAcgASgJEhcKD2NhbWVyYV9tb3ZlbWVudBgIIAEoCRIRCgllcXVpcG1lbnQYCSADKAkSDQoFcHJvcHMYCiADKAkSFgoOZGlyZWN0b3Jfbm90ZXMYCyABKAkSEAoIZHBfbm90ZXMYDCABKAkSEQoJdmZ4X25vdGVzGA0gASgJEhEKCXNmeF9ub3RlcxgOIAEoCRIQCghkaWFsb2d1ZRgPIAEoCRIVCg1zaG9vdGluZ190aW1lGBAgASgJIpwBChNDcmVhdGVTaG90c1Jlc3BvbnNlEkUKBnJlc3VsdBgBIAEoCzI1LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuQ3JlYXRlU2hvdHNSZXNwb25zZS5SZXN1bHQaPgoGUmVzdWx0EjQKBXNob3RzGAEgAygLMiUucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90YgZwcm90bzM", [file_vision_shotlist_v1_vision_shot]);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotsRequest
 */
export type CreateShotsRequest = Message<"protos.vision.shotlist.v1.CreateShotsRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateShotsRequest.Params params = 1;
   */
  params?: CreateShotsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotsRequest.
 * Use `create(CreateShotsRequestSchema)` to create a new message.
 */
export const CreateShotsRequestSchema: GenMessage<CreateShotsRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shots, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotsRequest.Params
 */
export type CreateShotsRequest_Params = Message<"protos.vision.shotlist.v1.CreateShotsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.CreateShotsRequest.NewShot shots = 2;
   */
  shots: CreateShotsRequest_NewShot[];
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotsRequest.Params.
 * Use `create(CreateShotsRequest_ParamsSchema)` to create a new message.
 */
export const CreateShotsRequest_ParamsSchema: GenMessage<CreateShotsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shots, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotsRequest.NewShot
 */
export type CreateShotsRequest_NewShot = Message<"protos.vision.shotlist.v1.CreateShotsRequest.NewShot"> & {
  /**
   * @generated from field: string shot_number = 1;
   */
  shotNumber: string;

  /**
   * @generated from field: string scene = 2;
   */
  scene: string;

  /**
   * @generated from field: string location = 3;
   */
  location: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated string cast_ids = 5;
   */
  castIds: string[];

  /**
   * @generated from field: string frame_size = 6;
   */
  frameSize: string;

  /**
   * @generated from field: string angle = 7;
   */
  angle: string;

  /**
   * @generated from field: string camera_movement = 8;
   */
  cameraMovement: string;

  /**
   * @generated from field: repeated string equipment = 9;
   */
  equipment: string[];

  /**
   * @generated from field: repeated string props = 10;
   */
  props: string[];

  /**
   * @generated from field: string director_notes = 11;
   */
  directorNotes: string;

  /**
   * @generated from field: string dp_notes = 12;
   */
  dpNotes: string;

  /**
   * @generated from field: string vfx_notes = 13;
   */
  vfxNotes: string;

  /**
   * @generated from field: string sfx_notes = 14;
   */
  sfxNotes: string;

  /**
   * @generated from field: string dialogue = 15;
   */
  dialogue: string;

  /**
   * @generated from field: string shooting_time = 16;
   */
  shootingTime: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotsRequest.NewShot.
 * Use `create(CreateShotsRequest_NewShotSchema)` to create a new message.
 */
export const CreateShotsRequest_NewShotSchema: GenMessage<CreateShotsRequest_NewShot> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shots, 0, 1);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotsResponse
 */
export type CreateShotsResponse = Message<"protos.vision.shotlist.v1.CreateShotsResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateShotsResponse.Result result = 1;
   */
  result?: CreateShotsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotsResponse.
 * Use `create(CreateShotsResponseSchema)` to create a new message.
 */
export const CreateShotsResponseSchema: GenMessage<CreateShotsResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shots, 1);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotsResponse.Result
 */
export type CreateShotsResponse_Result = Message<"protos.vision.shotlist.v1.CreateShotsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShot shots = 1;
   */
  shots: VisionShot[];
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotsResponse.Result.
 * Use `create(CreateShotsResponse_ResultSchema)` to create a new message.
 */
export const CreateShotsResponse_ResultSchema: GenMessage<CreateShotsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shots, 1, 0);

